type Peops = {
  idx: number
  children: JSX.Element
  translateX: number
}

export const ProgramsSlideContentContainer = ({
  idx,
  children,
  translateX,
}: Peops): JSX.Element => {
  return (
    <div className="overflow-hidden md:mt-[2.3vw]">
      <div
        className="flex flex-row transition-transform duration-[800ms]"
        style={{ transform: `translateX(${-translateX * idx}vw)` }}
      >
        {children}
      </div>
    </div>
  )
}
